import React from "react";
import { Field, ErrorMessage } from "formik";
// import { makeStyles } from "@mui/styles";
import "./Feild.css";

import TextField from "@mui/material/TextField";
export default function NewInputFeild({
  name = "name",
  Placeholder,
  defaultValue,
  rows = 1,
  multiline,
  type = "text",
  height,
  disabled,
  onChange,
  value,
}) {
  // const useStyles = makeStyles(() => ({
  //   text: {
  //     width: "100%",
  //     border: "none",
  //     padding: '0.5rem',
  //     color: "#41630F",
  //     "&:onclick": {
  //       border: "1px solid #41630F",
  //     },
  //   },
  // }));
  // const classes = useStyles();
  return (
    <div>
      <Field
        sx={{
          width: "100%",
        }}
        as={TextField}
        hiddenLabel
        id="filled-hidden-label-small"
        size="small"
        defaultValue={defaultValue}
        placeholder={Placeholder}
        fullWidth
        name={name}
        value={value}
        helperText={<ErrorMessage name={name}></ErrorMessage>}
        rows={rows}
        type={type}
        multiline={multiline}
        disabled={disabled}
        onChange={onChange}
        InputProps={{ inputProps: { min: 0 } }}
      ></Field>
    </div>
  );
}
